import React, { Component } from 'react';
import './App.scss';
import Header from './components/Header';
import Main from './components/Main';
import Info from './components/Info';
import Portfolio from './components/Porfolio';
import Skills from './components/Skills';

const Page = page => {
  switch (page) {
    case '0':
      return Info;
    case '1':
      return Skills;
    case '2':
      return Portfolio;
    default:
      return Info;
  }
};

class App extends Component {
  state = {
    lang: 'en',
    page: '0',
  };
  switchLang = e => {
    const lang = e.target.id;
    if (lang) {
      this.setState({ lang });
    }
  };
  switchPage = e => {
    if (e.target.type === 'submit') {
      document.querySelector('.btn.active').classList.remove('active');
      const id = e.target.id;
      const element = document.getElementById(id);
      element.classList.add('active');
      const page = id.split('-')[1];
      this.setState({ page });
    }
  };
  render() {
    const { lang, page } = this.state;
    const ViewPage = Page(page);
    return (
      <div className='App'>
        <Header
          lang={lang}
          switchLang={this.switchLang.bind(this)}
          switchPage={this.switchPage.bind(this)}
          page={page}
        />
        <Main lang={lang} Children={ViewPage} />
      </div>
    );
  }
}

export default App;
